import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { NgClass, NgOptimizedImage } from '@angular/common';
import { Component, computed, inject, input, output, signal, ViewEncapsulation } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Store } from '@ngrx/store';
import { CustomMatIcon, DRAGTYPES } from '@src/suite/common/enums/enums';
import { selectI18N } from '@src/suite/common/store/i18n/selectors/i18n.selectors';
import { MirAttachment, MosObjectType, mosTypeToIcon } from '@src/suite/common/utils/mos-utlis';

import { ExternalActionsOverlayComponent } from '../../../../playbook/components/external-actions-overlay/external-actions-overlay';

@Component({
    selector: 'st-attachments-list-item',
    imports: [ExternalActionsOverlayComponent, MatIcon, MatTooltip, NgClass, NgOptimizedImage],
    templateUrl: './attachments-list-item.html',
    styleUrl: './attachments-list-item.scss',
    encapsulation: ViewEncapsulation.None,
})
export class AttachmentsListItemComponent {
    MosObjectType = MosObjectType;
    CustomMatIcon = CustomMatIcon;

    // services
    store = inject(Store);

    // store selectors
    readonly languageService = computed(() => this.store.selectSignal(selectI18N)());

    // inputs
    readonly attachment = input<MirAttachment>();
    readonly disabled = input(false, {
        transform: coerceBooleanProperty,
    });
    readonly includeRaw = input(false, { transform: coerceBooleanProperty });
    readonly data = input<StorytellingRecord>();

    // outputs
    readonly openAttachment = output<MirAttachment>();

    // signals
    readonly showDetails = signal(false);

    // computed
    readonly hostClass = computed(() => `st-attachments-list-item--mos st-attachments-list-item--mos--${(this.attachment() as MirAttachment)?.objType?.toLowerCase()}`);
    readonly mosTypeIcon = computed(() => mosTypeToIcon((this.attachment() as MirAttachment)?.objType || MosObjectType.SUMMARY));
    readonly mosStatus = computed(() => {
        const status = (this.attachment() as MirAttachment)?.statusLabel;
        return this.languageService()?.[status] || '';
    });
    readonly mosStatusClass = computed(() => {
        const status = (this.attachment() as MirAttachment)?.status?.toLowerCase();
        if (!status) return '';
        return `st-attachments-list-item__status--${status}`;
    });

    dragStart(event: DragEvent) {
        if (!(this.attachment() as MirAttachment)?.mosItem) return;
        const dragData = {
            type: DRAGTYPES.AttachmentPool,
            data: (this.attachment() as MirAttachment)?.mosItem,
        };
        event.dataTransfer.setData('text/plain', JSON.stringify(dragData));
        event.dataTransfer.effectAllowed = 'copyMove';
        event.stopPropagation();
    }

    attachmentClick() {
        this.openAttachment.emit(this.attachment() as MirAttachment);
    }
}
